import { gql } from '@apollo/client';

export default gql`
  mutation CreateVoucher(
    $amount: Float!
    $market: String
    $validUntil: String!
    $type: CreatableVoucherType!
    $cid: String
    $title: String
    $firstName: String!
    $lastName: String!
    $recipientEmail: String!
    $bookingReference: String!
    $language: Language
    $associatedPNR: String
    $currency: Currency
  ) {
    createVoucher(
      amount: $amount
      market: $market
      channel: VOY
      validUntil: $validUntil
      type: $type
      cid: $cid
      title: $title
      firstName: $firstName
      lastName: $lastName
      recipientEmail: $recipientEmail
      bookingReference: $bookingReference
      language: $language
      associatedPNR: $associatedPNR
      currency: $currency
    ) {
      alias
      type
      amount
      currency
      validUntil
      datacashReference
    }
  }
`;
